import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import { Link } from "react-router-dom";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useAuth } from "context/AuthContext";

function NotAllowedPage() {
  const { role } = useAuth();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <Card>
          <SoftBox
            minHeight="60vh"
            px={3}
            py={6}
            display="flex"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            <SoftBox maxWidth="28rem">
              <SoftTypography variant="h2" fontWeight="bold" mb={1}>
                Your Role is not Sufficient to view this Resource!
              </SoftTypography>
              <SoftTypography variant="button" color="text" display="block" mb={4}>
                Your current role{role ? ` (${role})` : ""} does not have access to this page.
              </SoftTypography>
              <Button
                component={Link}
                to="/dashboard"
                variant="contained"
                color="info"
              >
                Back to dashboard
              </Button>
            </SoftBox>
          </SoftBox>
        </Card>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NotAllowedPage;
